export const imgUrl = (path) => {
  if (!path) return path;
  if (/^(https?:|data:|blob:)/.test(path)) return path;
  const token = localStorage.getItem('token');
  const rel = path.startsWith('/api/') ? path : `/api/storage/files/${path}`;
  const sep = rel.includes('?') ? '&' : '?';
  return `${process.env.REACT_APP_BACKEND_URL}${rel}${token ? `${sep}token=${encodeURIComponent(token)}` : ''}`;
};
